(function () {
  // Keeps "Add-on" products (upsells like Shipping Protection, Mystery Gift,
  // etc.) from ever sitting in the cart on their own. If the main product is
  // removed (from the cart drawer, the /cart page, or anywhere else), every
  // Add-on line item is automatically removed too — otherwise someone could
  // check out with only the $4.99 add-ons to snoop on order volume.
  if (window.__cartAddonGuardInstalled) return;
  window.__cartAddonGuardInstalled = true;

  var MUTATION_PATTERNS = ['/cart/change', '/cart/update', '/cart/add', '/cart/clear'];
  var busy = false;

  function isCartMutationUrl(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    for (var i = 0; i < MUTATION_PATTERNS.length; i++) {
      if (url.indexOf(MUTATION_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var isMutation = isCartMutationUrl(arguments[0]);
    var promise = originalFetch.apply(this, arguments);
    if (isMutation) {
      promise
        .then(function (res) {
          // Give the page's own cart-drawer refresh a moment to finish first.
          setTimeout(enforceGuard, 300);
          return res;
        })
        .catch(function () {});
    }
    return promise;
  };

  function refreshCartUI(state) {
    var parser = new DOMParser();
    if (state.sections && state.sections['cart-drawer']) {
      var doc = parser.parseFromString(state.sections['cart-drawer'], 'text/html');
      var freshDrawer = doc.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');
      if (freshDrawer && currentDrawer) {
        var wasActive = currentDrawer.classList.contains('active');
        currentDrawer.replaceWith(freshDrawer);
        if (wasActive) {
          if (typeof freshDrawer.open === 'function') {
            try {
              freshDrawer.open();
            } catch (e) {
              freshDrawer.classList.add('active');
            }
          } else {
            freshDrawer.classList.add('active');
          }
        }
      }
    }
    if (state.sections && state.sections['cart-icon-bubble']) {
      var iconDoc = parser.parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      var iconTarget = document.getElementById('cart-icon-bubble');
      if (iconTarget) iconTarget.innerHTML = iconDoc.body.innerHTML;
    }
  }

  function enforceGuard() {
    if (busy) return;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        var addonItems = cart.items.filter((i) => i.product_type === 'Add-on');
        var mainItemsCount = cart.items.length - addonItems.length;
        if (mainItemsCount > 0 || addonItems.length === 0) return;

        busy = true;
        var updates = {};
        addonItems.forEach((i) => {
          updates[i.key] = 0;
        });

        var cartDrawer = document.querySelector('cart-drawer');
        var sections =
          cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((s) => s.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((state) => {
            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
              return;
            }
            refreshCartUI(state);
          })
          .catch(function () {})
          .finally(() => {
            busy = false;
          });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceGuard);
  } else {
    enforceGuard();
  }
})();
